







import { Vue, Component } from "@/shared/vuepack";
import CommonTab from "@/employer/components/shared/CommonTab.vue";
import MyProgramMetrics from "@/employer/components/myprogram/MyProgramMetrics.vue";
import MyPlans from "@/employer/components/myplans/MyPlans.vue";

@Component({
  components: {
    CommonTab,
    MyProgramMetrics,
    MyPlans,
  }
})
export default class ProgramHealthTab extends Vue {}
